import { useAppDispatch, useAppSelector } from './redux';
import {
  MoneyKey,
  MONEY_KEYS,
  toggleAllMoney,
  toggleMoneyKey,
} from '../store/slices/dashboardPrivacySlice';

/** Lo que se pinta en lugar de la cifra. */
export const MONEY_MASK = '••••';

/**
 * Mampara de privacidad del dashboard: saber si una cifra va tapada y poder
 * taparla o destaparla. Ver dashboardPrivacySlice para el porqué y su alcance
 * (es una mampara visual, no un permiso).
 */
export const useMoneyPrivacy = () => {
  const dispatch = useAppDispatch();
  const hidden = useAppSelector(state => state.dashboardPrivacy.hidden);

  const isHidden = (key: MoneyKey) => hidden.includes(key);
  const allHidden = MONEY_KEYS.every(k => hidden.includes(k));

  return {
    isHidden,
    allHidden,
    /** Alguna cifra tapada: sirve para marcar el botón general como activo. */
    anyHidden: hidden.length > 0,
    toggle: (key: MoneyKey) => dispatch(toggleMoneyKey(key)),
    toggleAll: () => dispatch(toggleAllMoney()),
    /** Devuelve la máscara o el valor, para envolver una cifra ya formateada. */
    mask: (key: MoneyKey, formatted: string) =>
      hidden.includes(key) ? MONEY_MASK : formatted,
  };
};
